// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
  body * {
    visibility: hidden;
  }

  #printable-order-details,
  #printable-order-details * {
    visibility: visible;
  }

  #printable-order-details {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }

  #delivery-note-content,
  #delivery-note-content * {
    visibility: visible;
  }

  #delivery-note-content {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }

  .thermal-receipt,
  .thermal-receipt *,
  .thermal-print-wrap,
  .thermal-print-wrap *,
  .thermal-side-images,
  .thermal-side-images * {
    visibility: visible;
  }

  /* Default: pin .thermal-receipt to the page origin (used by ThermalPrint.tsx which has no wrap) */
  .thermal-receipt {
    position: absolute;
    left: 0;
    top: 0;
  }

  /* When a .thermal-print-wrap is present (DeliveryNotePrint.tsx), pin the wrap instead
     and let the receipt inside flow normally so the inline-block image column sits next to it */
  .thermal-print-wrap {
    position: absolute;
    left: 0;
    top: 0;
  }

  .thermal-print-wrap .thermal-receipt {
    position: static;
    left: auto;
    top: auto;
  }

  .no-print {
    display: none !important;
  }

  /* Expand textareas (e.g. Additional Notes) to show full content */
  .flex-grow-1.border.rounded.bg-white.p-2 {
    max-height: none !important;
    overflow: visible !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/custom.css"],"names":[],"mappings":"AAAA;EACE;IACE,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;EACb;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;EACb;;EAEA;;;;;;IAME,mBAAmB;EACrB;;EAEA,kGAAkG;EAClG;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;EACR;;EAEA;gGAC8F;EAC9F;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;EACR;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,kEAAkE;EAClE;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;AACF","sourcesContent":["@media print {\r\n  body * {\r\n    visibility: hidden;\r\n  }\r\n\r\n  #printable-order-details,\r\n  #printable-order-details * {\r\n    visibility: visible;\r\n  }\r\n\r\n  #printable-order-details {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%;\r\n  }\r\n\r\n  #delivery-note-content,\r\n  #delivery-note-content * {\r\n    visibility: visible;\r\n  }\r\n\r\n  #delivery-note-content {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%;\r\n  }\r\n\r\n  .thermal-receipt,\r\n  .thermal-receipt *,\r\n  .thermal-print-wrap,\r\n  .thermal-print-wrap *,\r\n  .thermal-side-images,\r\n  .thermal-side-images * {\r\n    visibility: visible;\r\n  }\r\n\r\n  /* Default: pin .thermal-receipt to the page origin (used by ThermalPrint.tsx which has no wrap) */\r\n  .thermal-receipt {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n  }\r\n\r\n  /* When a .thermal-print-wrap is present (DeliveryNotePrint.tsx), pin the wrap instead\r\n     and let the receipt inside flow normally so the inline-block image column sits next to it */\r\n  .thermal-print-wrap {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n  }\r\n\r\n  .thermal-print-wrap .thermal-receipt {\r\n    position: static;\r\n    left: auto;\r\n    top: auto;\r\n  }\r\n\r\n  .no-print {\r\n    display: none !important;\r\n  }\r\n\r\n  /* Expand textareas (e.g. Additional Notes) to show full content */\r\n  .flex-grow-1.border.rounded.bg-white.p-2 {\r\n    max-height: none !important;\r\n    overflow: visible !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
